'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _AjaxCart = require('components/InlineCart/AjaxCart.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = {
  feelingLucky: 'data-feeling-lucky'
};

/**
 * Randomizes an array of products
 *
 * @param {Array} products: products to randomize
 *
 * @return {Array}: randomized array of products
 */
var randomizeProducts = function randomizeProducts(products) {
  return [].concat((0, _toConsumableArray3.default)(products)).filter(function (product) {
    return product !== false;
  }).sort(function (a, b) {
    return Math.random() - Math.random();
  });
};

/**
 * Builds JSON to pass to Shopify's '/cart/add.js'
 *
 * @param {Array} products: the products to add to cart
 *
 * @return {JSON}: the JSON string to pass to the endpoint
 */
var buildATCJSON = function buildATCJSON(productsToAdd) {
  return JSON.stringify({
    items: productsToAdd.map(function (product) {
      return {
        quantity: 1,
        id: product
      };
    })
  });
};

/**
 * Adds three random products to the cart and will reload the cart
 */
var addItemsToCart = function addItemsToCart() {
  var products = randomizeProducts(window.feelingLuckyProducts);
  var itemJSON = buildATCJSON(products.slice(0, 3));
  console.log(itemJSON);
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: itemJSON
  }).then(function (blob) {
    return blob.json();
  }).then(function (data) {
    (0, _AjaxCart.fetchFullCart)();
    (0, _AjaxCart.fetchInlineCart)(true);
    // need to update CartJS cart object
    return CartJS.getCart();
  }).then(function (data) {
    var items_discounts = data.items.map(function (item) {
      return item.discounts[0];
    });
    if (items_discounts[0]) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'cartScriptApplied',
        'scriptDetails': items_discounts[0].title
      });
    }
  });
};

/**
 * Setup listeners for the inline cart's "I'm feeling lucky" button
 */
var setup = function setup() {
  document.addEventListener('click', function () {
    var feelsLucky = event.target.hasAttribute(dom.feelingLucky) || false;
    feelsLucky && addItemsToCart();
  });
};

exports.default = {
  setup: setup
};